import styled from "styled-components";
import { Shimmer } from "../common/Loading.styles";

export const CommentItem = styled.div(() => `
    display: flex;

    .btn {
        margin-left: 12px;
        margin-top: 8px;

        svg {
            margin-left: 0;
        }
    }
`)

export const CommentItemBody = styled.div(({ theme }) => `
    padding: 8px 12px;
    flex-grow: 1;
    border-radius: ${theme.rounded.sm};
    background: ${theme.placeholderColor};
    margin-bottom: 12px;
`)

export const LoadingLine = styled(Shimmer)`
    &.content-line {
        max-width: 120px;
        margin-bottom: 0;
    }
`

export const CommentMeta = styled.div`
    display: flex;
    margin-top: 12px;
    justify-content: space-between;
    align-items: center;
`

export const AnswerRowWrapper = styled.div(({ theme }) => `
    flex-grow: 1;

    ${theme.breakpoints.up('md')} {
        && {
            margin-top: -10px;
        }
    }
`)